import './style.scss';
import { useState } from "react";
import classnames from 'classnames';
import { useHistory, useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import AllImports from "./AllImports";
import ContactImport from "./ContactImport";
import { CONTACT_IMPORTS, CSV_IMPORTS, LOOKUP_IMPORTS } from "../../constants";


const ImportCSV = () => {
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(new URLSearchParams(location.search).get('activeTab') || '1');
  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      history.push(`${location?.pathname}?activeTab=${tab}`);
    }
  };

  return (
    <div>
      <h5 className="m-0 mb-4">{CSV_IMPORTS}</h5>

      {/* Tab Navigation */}
      <div className="ImportToolTabWrapper">
        <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => {
                  toggleTab('1');
                }}
              >
                {LOOKUP_IMPORTS}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => {
                  toggleTab('2');
                }}
            >
                {CONTACT_IMPORTS}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1" className="tab-pane-padding">
            <AllImports adminImport={false} />
          </TabPane>
          <TabPane tabId="2" className="tab-pane-padding">
            <ContactImport adminImport={false} />
          </TabPane>
      </TabContent>
      </div>
  </div>
  )
}

export default ImportCSV;